import { AnyAction } from 'redux';
import { Inception } from '../../../core/datasets/action';

export const inceptionActionMatcher = (action: AnyAction): ((type: Inception) => boolean) => {
    return function (type: Inception) {
        return action.type === type;
    };
};
